module.exports = __webpack_public_path__ + "a528e59550b224628cbd7e6c6e840ab9.svg";